{
  "version": 1,
  "asset_id": "6ade65de-3e0f-4556-9659-8849820340b1",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/6ade65de-3e0f-4556-9659-8849820340b1/southend-drone-poster-640.avif",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/6ade65de-3e0f-4556-9659-8849820340b1/southend-drone-poster-640.avif",
  "original_filename": "southend-drone-poster-640.avif",
  "size": 30381,
  "content_type": "image/avif",
  "created_at": "2026-07-22T22:52:12Z"
}
